import classNames from 'classnames'
import { useMemo, useState } from 'react'
import { ReportPdfMenuItems } from '../../../components/report-pdf-menu/ReportPdfMenu'
import { useOutsideClick } from '../../../hooks/useOutsideClick'
import type { ReportPdfLink } from '../../../utils/reportPdfLinks'

import styles from './DownloadComponent.module.css'

type MenuAlign = 'end' | 'center'

function DownloadComponent({
  item,
  isSmallSize,
  iconText,
  menuAlign = 'end',
}: {
  item: any
  isSmallSize?: boolean
  iconText?: string
  menuAlign?: MenuAlign
}) {
  const [isVisibleDownloadList, setIsVisibleDownloadList] = useState(false)
  const ref = useOutsideClick(() => {
    setIsVisibleDownloadList(false)
  })

  const pdfItems = useMemo(() => {
    const items: ReportPdfLink[] = []
    if (item?.pdf_url) {
      items.push({ title: 'Скачать', path: item.pdf_url })
    }
    if (item?.pdf_with_stamp_url) {
      items.push({ title: 'Скачать с печатью', path: item.pdf_with_stamp_url })
    }
    return items
  }, [item?.pdf_url, item?.pdf_with_stamp_url])

  if (!pdfItems.length) return null

  return (
    <div
      onClick={() => setIsVisibleDownloadList(true)}
      className={classNames(
        styles.dropdown,
        menuAlign === 'end' && styles.dropdownLeft,
        menuAlign === 'center' && styles.dropdownCenter,
        styles.dropdownUp
      )}
    >
      <div
        className={classNames(
          styles.btn,
          styles.btnSmall,
          { [styles.btnDropdown]: !isSmallSize },
          styles.btnOutline,
          styles.btnIcon,
          { [styles.btnBlue]: Boolean(iconText) }
        )}
      >
        <i
          className={classNames(styles.icon, styles.iconDownload, {
            [styles.iconWhite]: Boolean(iconText),
          })}
        />
      </div>
      {isVisibleDownloadList && (
        <div
          ref={ref}
          className={classNames(styles.dropdownContent, styles.small2)}
          onClick={(event) => event.stopPropagation()}
        >
          <ReportPdfMenuItems items={pdfItems} />
        </div>
      )}
    </div>
  )
}

export default DownloadComponent
